import { PERSONALIZATION_API_HOST, PERSONALIZATION_API_KEY } from './constants';

const getUserNewsletterSubscriptions = async (email: string) => {
  const response = await fetch(`${PERSONALIZATION_API_HOST}/getUserNewsletterSubscriptions?email=${email}`, {
    headers: {
      'x-api-key': PERSONALIZATION_API_KEY,
    },
    method: 'GET',
  });

  if (!response.ok) throw new Error('API error');

  return (await response.json()) as string[];
};

export default getUserNewsletterSubscriptions;
